export const contact = {
  title: 'اتصل بنا',
  subtitle: 'نحن هنا لمساعدتك. لا تتردد في الاتصال بنا لأي سؤال.',
  form: {
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    subject: 'الموضوع',
    message: 'الرسالة',
    submit: 'إرسال'
  }
}; 